/**
 * Puces « SKILLCARDS reliées » d'un exercice, sur sa fiche tuteur (lecture
 * seule). N'affiche que les cartes dont le tuteur est l'auteur (RLS) ; rien si
 * aucune.
 */

import { Link } from '@tanstack/react-router';
import { Layers } from 'lucide-react';
import { useExerciseCards } from '@/lib/cards/questions';
import { MathText } from '@jeraisonne/ui';

export function ExerciseCardsChips({ exerciseId }: { exerciseId: string }) {
  const cards = useExerciseCards(exerciseId);
  if (!cards.data || cards.data.length === 0) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      <span className="text-ink-500 text-xs">Cartes reliées :</span>
      {cards.data.map((c) => (
        <Link
          key={c.card_id}
          to="/tutor/cards/$cardId"
          params={{ cardId: c.card_id }}
          className="bg-primary-50 text-primary-700 inline-flex min-h-[2rem] items-center gap-1 rounded-full px-2.5 text-xs font-semibold"
        >
          <Layers className="h-3.5 w-3.5" />
          <MathText>{c.title}</MathText>
          <span className="text-primary-500 font-normal">
            · {c.question_count} question{c.question_count > 1 ? 's' : ''}
          </span>
        </Link>
      ))}
    </div>
  );
}
